import type { NotificationProviderProps } from "@intrasync/react";

/**
 * The toast stack's size, per width band (walkthrough §2.5).
 *
 * The library default (notistack `maxSnack: 3`, full padding) stacked toasts to
 * 720px on a phone, burying the page under them. notistack has no "collapse"
 * option, so on a phone only ONE toast shows at a time — later ones queue
 * behind it rather than being dropped — and in the dense layout. Wider screens
 * keep the library defaults.
 */
export function toastStackProps(
  isPhone: boolean
): Pick<NotificationProviderProps, "maxSnack" | "dense"> {
  return isPhone ? { maxSnack: 1, dense: true } : {};
}
